module.exports = __webpack_public_path__ + "img/phone-screen-tr.67eae5ae.png";